export class NotNotificationSettings {
  id: number;
  noT_Id: number;
  noT_UTE_Id: number;
  noT_MOD_Id: number;
  noT_Type: number;
  noT_TypeID: number;
}
